import { Component, inject } from '@angular/core';
import { environment } from '../environments/environment';
import { windowDebug } from '../tools/debug';
import { Title } from '@angular/platform-browser';
import { MarkdownRendererService } from '../services/markdown-renderer.service';
import { EntryApi } from '../data/entry/entry.api';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  // required for setting up
  private mrs = inject(MarkdownRendererService);

  private entryApi = inject(EntryApi);

  appVersion?: string;

  constructor(title: Title) {
    windowDebug('AppComponent', this);

    this.fetchVersion();

    // AndroidFullScreen.isImmersiveModeSupported()
    //   .then(() => AndroidFullScreen.showSystemUI())
    //   .catch(console.warn);

    if (!environment.production) {
      title.setTitle('dc3 DEV')
    }
  }

  fetchVersion() {
    fetch('./assets/version.json')
      .then(res => res.json()
        .then(data => this.appVersion = data.version));

  }
}
